
'use strict';

import renderIndex from './render-index';

export default renderIndex;

